import React, { Component } from "react";
import StepWizard from 'react-step-wizard';
//// componentes reutilizables
import Titulo from "../../../generico/TituloPagina";
import Paso1 from "./AgregarPaso1";
import Paso2 from "./AgregarPaso2";
import Paso3 from "./AgregarPaso3";


export default class AgregarDebito extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cuenta_debito: undefined,
      modalidad: undefined,
      nroModalidad: undefined,
      cuenta_credito: undefined,
      cuenta: undefined,
      msg_paso2: undefined,
      porcentaje: undefined, 
      rptPaso1: undefined
    };

  }

  componentDidMount() {
   
  }
  respuestaPaso1 = (respuesta, modalidad, cuenta) => {
   
    if(respuesta[0].nroModalidad === "10"){
     // console.log(respuesta[0])
    this.setState({rptPaso1: respuesta[0], modalidad: modalidad, cuenta: cuenta, porcentaje: respuesta[0].TC_porcentaje });
  } 
  else {
    //console.log(respuesta[0])
    this.setState({rptPaso1: respuesta[0],  modalidad: modalidad, cuenta: cuenta });
  }  
  };
 
  respuestaPaso2 = (respuesta, paso1, modalidad) => {
    /*console.log(respuesta)
    console.log(paso1)
    
    console.log(modalidad)*/
    this.setState({ msg_paso2: respuesta, rptPaso1: paso1,  modalidad: modalidad});
  };

 
  render() {
      return (
        <div className="content-wrapper">
          <Titulo texto="Agregar Débito Automatico"/>
          <section className="content">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                          <StepWizard transitions='none'>
                              <Paso1 respuestaPaso1={this.respuestaPaso1.bind(this)}/>
                              <Paso2 rptPaso1= {this.state.rptPaso1} respuestaPaso2={this.respuestaPaso2.bind(this)} cuenta= {this.state.cuenta}/>
                              <Paso3 paso2 = {this.state.msg_paso2} modalidad ={this.state.modalidad} rptPaso1= {this.state.rptPaso1}/>
                          </StepWizard> 
                     </div>    
                  </div>                    
                </div> 
              </div>
            </div>           
          </section> 
        </div>
     
      );
  }
}